import { FiPlus } from 'react-icons/fi';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`;

export const MainContent = styled.div`
  padding: 1rem;
`;

export const MainTitle = styled.p`
  padding: 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: var(--text-body);
  border-bottom: 1px solid var(--black-light);
`;

export const SectionListQuestions = styled.div`
  margin-top: 4rem;
  max-height: 580px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QuestionCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem;
  max-width: 620px;
  box-shadow: 0px 0px 4px 3px #eeeeee;
  padding: 1rem;
`;

export const QuestionCardHeader = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--text-body);
  text-align: center;
  padding-top: 0.5rem;
  border-bottom: 1px solid var(--black-light);
  padding-bottom: 0.5rem;
`;

export const QuestionCardContent = styled.div`
  margin-top: 1rem;
  color: var(--text-body);
  border-bottom: 1px solid var(--black-light);
  padding-bottom: 1rem;

  > p {
    font-weight: bold;
    margin-top: 0.5rem;

    span {
      font-weight: 500;
    }
  }
`;

export const QuestionCardOption = styled.p`
  font-weight: 500 !important;

  & + p {
    margin-top: 0.5rem;
  }
`;

export const QuestionCardFooter = styled.div`
  margin-top: 1rem;
  display: flex;
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;

  span {
    background-color: var(--black-light);
    font-size: 1.125rem;
    padding: 0.5rem 1rem;
    margin: 0 0.125rem;
  }
`;

export const ArrowLeft = styled.button`
  background-color: var(--primary);
  padding: 0.5rem 1rem;
  color: var(--white);
  border-radius: 5px;
  cursor: pointer;

  svg {
    font-size: 17px;
  }

  &:disabled {
    background-color: var(--background-modal);
  }
`;

export const ArrowRight = styled.button`
  background-color: var(--primary);
  color: var(--white);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;

  svg {
    font-size: 17px;
  }

  &:disabled {
    background-color: var(--background-modal);
  }
`;

export const NoQuestions = styled.p`
  font-size: 1.5rem;
  text-align: center;
  color: var(--text-body);
  position: absolute;
  top: 50%;
  left: 50%;
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  max-width: 250px;
  height: 45px;
  background-color: var(--primary);
  color: var(--white);
  border-radius: 10px;
  transition: background-color 0.3s;
  text-transform: uppercase;

  &:hover {
    background: var(--primary-hover);
  }

  & + button {
    margin-left: 0.5rem;
  }
`;

export const IconPlus = styled(FiPlus)`
  font-size: 18px;
  margin-right: 1rem;
`;
